import { Plus, X } from "@tamagui/lucide-icons";
import { GestureResponderEvent } from "react-native";

import { Button } from "./Button";
import { Text } from "./Typography";

export default function Chip({
  text,
  onPress,
  disabled,
  selected,
}: {
  text: string;
  onPress: (event: GestureResponderEvent) => void;
  disabled?: boolean;
  selected?: boolean;
}) {
  const Icon = selected ? X : Plus;
  return (
    <Button.Wrapper
      flexDirection="row"
      alignItems="center"
      gap="$50"
      paddingVertical="$50"
      paddingHorizontal="$100"
      dataTrackingId={selected ? "remove-suggestion" : "suggestion"}
      onPress={onPress}
      disabled={disabled}
      opacity={disabled ? 0.5 : 1}
      backgroundColor="$fillNeutral"
      hoverStyle={{
        scale: 1.03,
      }}
      focusVisibleStyle={{
        outlineStyle: "solid",
        outlineColor: "$a11yBlue",
        outlineWidth: 2,
        outlineOffset: 2,
      }}
    >
      <Icon size="$200" />
      <Text color="$textSecondary" size="$button">
        {text}
      </Text>
    </Button.Wrapper>
  );
}
